// app/store.js
import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./Slices/AuthSlice";
import { setupListeners } from "@reduxjs/toolkit/query";
import { authApi } from "./Apis/AuthApi";
import { manageUserApi } from "./Apis/manageUserApi";
import { dashboardApi } from "./Apis/dashboardApi";
import { rolePermissionApi } from "./Apis/rolePermissionApi";
import { outletApi } from "./Apis/outletApi";
import { servicesApi } from "./Apis/servicesApi";
import { bookingApi } from "./Apis/bookingApi";
import { customerApi } from "./Apis/customerApi";
import { supplierApi } from "./Apis/supplierApis";
import { reportApi } from "./Apis/reportApi";
import { toolsApi } from "./Apis/toolsApi";
import { creditAccountApi } from "./Apis/CreditAccountApi";

const Store = configureStore({
  reducer: {
    auth: authReducer,
    [authApi.reducerPath]: authApi.reducer,
    [dashboardApi.reducerPath]: dashboardApi.reducer,
    [bookingApi.reducerPath]: bookingApi.reducer,
    [customerApi.reducerPath]: customerApi.reducer,
    [manageUserApi.reducerPath]: manageUserApi.reducer,
    [rolePermissionApi.reducerPath]: rolePermissionApi.reducer,
    [outletApi.reducerPath]: outletApi.reducer,
    [servicesApi.reducerPath]: servicesApi.reducer,
    [supplierApi.reducerPath]: supplierApi.reducer,
    [reportApi.reducerPath]: reportApi.reducer,
    [toolsApi.reducerPath]: toolsApi.reducer,
    [creditAccountApi.reducerPath]: creditAccountApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      authApi.middleware,
      dashboardApi.middleware,
      bookingApi.middleware,
      customerApi.middleware,
      manageUserApi.middleware,
      rolePermissionApi.middleware,
      outletApi.middleware,
      servicesApi.middleware,
      supplierApi.middleware,
      reportApi.middleware,
      toolsApi.middleware,
      creditAccountApi.middleware
    ),
});
setupListeners(Store.dispatch);

export default Store;
